var React = require('react');

function UstaDownload (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M8 .667v10M12 6.667l-4 4-4-4M14.666 14.666H1.333"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0H16V16H0z"})))]);
}

UstaDownload.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = UstaDownload;

UstaDownload.default = UstaDownload;
